import React from "react";
import Loading from "../../../../Common/Loading";
import { renderHeaderPrice } from "../../../../Common/Function/index";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import InSetBoxShadow from "../../../../Common/InSetBoxShadow";
import Cards from "../Cards";
const FlatList = ({ data, loading, search, handleFilter, searchHandler }) => {
  const Empty = () => {
    return (
      <div className="col-12 text-center mt-5">
        <p className="mb-5">کلاس ورزشی ای یافت نشد</p>
      </div>
    );
  };
  if (loading) {
    return (
      <>
        <Loading margin={""} count={4} col={12} />
      </>
    );
  }

  return (
    <>
      {data && data.data
        ? data.data.length === 0
          ? Empty()
          : data.data
          ? data.data.map((item, id) => {
              return <Cards item={item} key={id} />;
            })
          : Empty()
        : Empty()}
      <div className="d-flex align-items-center justify-content-center">
        {loading || (data && data.data && data.length == 0) ? (
          ""
        ) : (
          <Pagination
            activePage={data && data.current_page}
            itemsCountPerPage={15}
            totalItemsCount={data && data.total}
            onChange={page => {
              handleFilter("page", page);
            }}
            itemClass={"page-item"}
            linkClass={"page-link"}
            // hideFirstLastPages={true}
          />
        )}
      </div>
    </>
  );
};

export default FlatList;
const Card = ({ data }) => {
  return (
    <div
      className=""
      style={{
        marginBottom: "10px",
      }}
    >
      <Link to={`/Items/${data.slug}`}>
        <InSetBoxShadow>
          <div
            className="item overflow-hidden d-flex justify-content-between"
            style={{
              overflow: "hidden",
              height: "130px",
            }}
          >
            <img
              src={data && data.images && data.images[0]}
              alt={data ? data.name : "nikotan | نیکوتن"}
              className="img-fluid"
              style={{ width: "200px" }}
            />
            <div
              className="texts p-2 justify-content-between"
              style={{ minHeight: "auto", flex: 3 }}
            >
              <div className="first-part d-flex flex-wrap justify-content-between  ">
                <h5 style={{ color: "#404040" }} className=" name">
                  {data.name}
                </h5>
              </div>
              <div className="second-part h6 d-flex flex-wrap justify-content-between mb-2">
                <p
                  className="address mb-2"
                  style={{ color: "#6B6B6B", fontSize: "15px" }}
                >
                  {data && data.address}
                </p>
              </div>
              <div className="d-flex justify-content-end">
                {data &&
                  data.itemoptins &&
                  data.itemoptins.map((option, key) => (
                    <i
                      key={key}
                      className={option.icon}
                      style={{ color: "#000" }}
                    />
                  ))}
              </div>
            </div>
            <div
              className="p-3 d-flex flex-column justify-content-between"
              style={{ borderRight: "1px solid #eee", flex: 1 }}
            >
              <div className="d-flex justify-content-end align-items-center">
                <h6 style={{ padding: "0", margin: "0" }}>
                  {data.comments_avg_score || 5}
                </h6>

                <img
                  src={window.origin + "/WebSide/assets/images/star.png"}
                  alt="امتیاز"
                  style={{ width: "15px", height: "15px", marginRight: "5px" }}
                />
              </div>
              <div className="text-center">
                <p className="" style={{ textAlign: "right" }}>
                  شروع قیمت از
                </p>
              </div>

              {data && (
                <div className="d-flex flex-column  px-1 align-items-center">
                  <div className="label-price px-5 py-1">
                    <span className=" text-white">
                      {data.header_price
                        ? `${renderHeaderPrice(data)}`
                        : renderHeaderPrice(data)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </InSetBoxShadow>
      </Link>
    </div>
  );
};
